<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem" bgColor="#fff">
      <div class="game-1-box">
        <!-- <div class="game-1-box-title">当前：第1/8页</div> -->
        <div class="game-1-box-list">
          <!-- 左右滑动，一个Swipeitem中有8张图片，一行4个 -->
          <div
            class="game-1-box-list-item"
            v-for="(item, index) in formValue.cardList"
            :key="index"
          >
            <div class="game-1-box-list-item-left">
              <VanImage
                height="1.2rem"
                width="1.2rem"
                :src="item.avatar"
                fit="cover"
                radius="5"
              />
              <div style="text-align: center">
                {{ item.nickName }}
              </div>
            </div>

            <div
              class="game-1-box-list-item-right"
              v-show="gameInfo.visibleType != 'wheel'"
            >
              <template v-if="(item.records || []).length > 0">
                <Grid :column-num="3" :border="false">
                  <GridItem
                    v-for="(subitem, subindex) in item.records"
                    :key="subindex"
                  >
                    <NfBrand
                      trigger="custom"
                      height="2.5rem"
                      :onlyKey="`brand-${subindex}`"
                      v-model="item.brandStatus"
                    >
                      <template #cz>
                        <VanImage
                          height="2.5rem"
                          :src="
                            subitem.isFront != 1
                              ? subitem.reverseImg
                              : subitem.frontImg
                          "
                          fit="cover"
                          radius="5"
                        />
                      </template>
                      <template #cf>
                        <VanImage
                          height="2.5rem"
                          :src="
                            subitem.isFront != 1
                              ? subitem.frontImg
                              : subitem.reverseImg
                          "
                          fit="cover"
                          radius="5"
                        />
                      </template>
                      <div
                        class="game-1-box-list-item-right-open"
                        @click.stop="previewImgHandle(subitem)"
                      >
                        <Icon name="search" size="0.3rem" />
                      </div>
                    </NfBrand>
                  </GridItem>
                </Grid>
              </template>
              <template v-else>
                <div class="game-1-box-list-right-empty">
                  <Empty image-size="0" description="用户还未抽取卡牌" />
                </div>
              </template>
              <template v-if="gameInfo.flip">
                <NfButton
                  color="rgb(255,211,94)"
                  round=".5rem"
                  style="margin-top: 0.2rem"
                  @click.native="brandHandle(item)"
                  >{{ item.isOpen ? "（已启用）" : "" }}启动翻面</NfButton
                >
              </template>
            </div>

            <div
              class="game-1-box-list-item-right"
              v-show="gameInfo.visibleType == 'wheel'"
              style="width: 5.8rem"
            >
              <template v-if="(item.records || []).length > 0">
                <WheelRecord
                  :value="item.records"
                  width="250px"
                  height="250px"
                />
              </template>
              <template v-else>
                <div class="game-1-box-list-right-empty">
                  <Empty image-size="0" description="用户还未打分" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </nf-card>

    <nf-card
      round=".2rem"
      style="margin-top: 0.2rem"
      bgColor="#fff"
      v-if="gameStatus == 1"
    >
      <div class="game-1-box">
        <div>初始轮卡牌设置：</div>
        <div class="game-1-box-init">
          <Grid :column-num="2" :border="false" gutter="0.2rem">
            <GridItem v-for="item in formValue.initCardList" :key="item.id">
              <nf-card
                @click.native="changeCardType(item.id, item.cardCategoryName)"
                :borderColor="formValue.cateId == item.id ? '#ACB9E8' : ''"
                :borderSize="
                  formValue.cateId == item.id ? '0.02rem' : '0.01rem'
                "
                class="game-1-box-init-card"
              >
                <div class="game-1-box-init-card-top">
                  {{ item.cardCategoryName }}
                </div>
                <div class="game-1-box-init-card-center">
                  <img
                    class="game-1-box-init-card-center-img"
                    :src="item.secondImg || item.img"
                    mode="scaleToFill"
                  />
                </div>
                <div class="game-1-box-init-card-bottom">
                  <RadioGroup
                    v-model="formValue.secondCateId"
                    class="game-1-box-init-card-bottom-group"
                  >
                    <Radio
                      v-for="subItem of item.children"
                      :name="subItem.id"
                      :key="subItem.id"
                      @click.prevent="changeSubCardType(item, subItem)"
                    >
                      {{ subItem.cardCategoryName }}
                      <template #icon="props">
                        <img
                          class="game-1-box-init-box-item-icon"
                          :src="props.checked ? activeIcon : inactiveIcon"
                        />
                      </template>
                    </Radio>
                  </RadioGroup>
                </div>
              </nf-card>
            </GridItem>
          </Grid>
          <div class="game-1-box-init-select">
            <div style="display: flex; align-items: center">
              <div>本轮最多可抽</div>
              <NfInput
                width="20%"
                round=".1rem"
                borderInnerSize="0.01rem"
                type="text"
                :value.sync="formValue.extractNum"
                :disabled="limitDisabled"
              />
              <div>张卡牌</div>
            </div>
            <NfButton width="20%" @click.native="dealCardHandle">发牌</NfButton>
          </div>
        </div>
      </div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import NfBrand from "@/components/game-ui/NfBrand.vue";
import NfInput from "@/components/game-ui/NfInput.vue";
import NfDropdownMenu from "@/components/game-ui/NfDropdownMenu.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  RadioGroup,
  Radio,
  Empty,
  ImagePreview,
  Icon,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import activeIcon from "@/assets/game/checked.png";
import inactiveIcon from "@/assets/game/no_checked.png";
import { getGameConfig } from "../../config";
import WheelRecord from "@/components/game-comm/WheelRecord.vue";
// import
import $store from "@/store";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {
          flip: false,
        };
      },
    },
    gameStatus: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    formValue: {
      get: () => {
        return $store.state.game.discus.form;
      },
      set: (val) => {
        $store.commit("GAME_DISCUS_FORM", val);
      },
    },
  },
  data() {
    return {
      activeIcon,
      inactiveIcon,
      list: [],
      brandStatus: false,
      limitDisabled: false,
    };
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    NfInput,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    NfBrand,
    RadioGroup,
    Radio,
    NfDropdownMenu,
    Empty,
    WheelRecord,
    ImagePreview,
    Icon,
  },
  methods: {
    getGameConfig,
    changeCardType(value, name) {
      const item = this.formValue.initCardList.find(
        (item) => item.id === value
      );
      if (item.children.length > 0) {
        this.changeSubCardType(item, item.children[0]);
      } else {
        this.formValue.secondCateId = 0;
      }

      this.formValue.cateId = value;
      this.formValue.cateName = name;
    },
    changeSubCardType(item, secondItem) {
      this.formValue.secondCateId = 0;
      // 修改item下的图片
      item.secondImg = secondItem.img;
      this.formValue.secondCateId = secondItem.id;
      this.formValue.secondCateName = secondItem.cardCategoryName;
      this.changeLimitNum(item.id, secondItem.id);
    },
    // 教练点击发牌
    dealCardHandle() {
      // 确认进入下一轮提示
      this.$emit("dealCard");
    },
    brandHandle(item) {
      item.brandStatus = !item.brandStatus;
      item.isOpen = true;
      this.formValue.playerList.map((subItem) => {
        if (subItem.id == item.playerId) {
          subItem.isOpen = true;
        }
      });

      this.$emit("flip", item);
    },
    changeLimitNum(cateId, secondCateId) {
      const config = getGameConfig(cateId, secondCateId);
      console.log("limitNum", limitNum, config, cateId, secondCateId);
      const limitNum = config.limitNum;
      if (limitNum !== undefined) {
        this.formValue.extractNum = limitNum;
        this.limitDisabled = true;
      } else {
        this.limitDisabled = false;
        this.formValue.extractNum = 1;
      }
    },
    previewImgHandle(item) {
      const img = item.brandStatus ? item.reverseImg : item.frontImg;
      ImagePreview({
        images: [img],
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-item {
        display: flex;

        &-left {
          padding: 0.1rem;
          border-right: 0.02rem dashed #666;
          &-avatar {
            margin-bottom: 0.2rem;
          }
        }
        &-right {
          width: 100%;

          &-open {
            position: absolute;
            top: -0.15rem;
            right: -0.15rem;
            border-radius: 50%;
            width: 0.6rem;
            height: 0.6rem;
            background: #eee;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }
    }

    &-init {
      margin-top: 0.3rem;
      font-size: 0.2rem;
      color: #999;

      &-box {
        width: 100%;
        display: flex;
        &-item {
          width: 50%;
          padding: 0 0.1rem;
          padding: 0 0.3rem;
          &-icon {
            height: 0.3rem;
          }
        }
      }

      &-card {
        &-top {
          color: #666;
          font-size: 0.25rem;
          // font-weight: bold;
          line-height: 1.8;
          text-align: center;
        }
        &-center {
          height: 2.3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 0.1rem;
          &-img {
            // width: 1.8rem;
            height: 100%;
            // border-radius: 0.1rem;
            overflow: hidden;
          }
        }
        &-bottom {
          margin-top: 0.1rem;
          height: 0.5rem;
          &-group {
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
        }
      }
      &-select {
        margin-top: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-box {
        }
      }

      &-setting {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-text {
          flex-shrink: 0;
        }
      }
    }
  }

  ::v-deep .van-radio__label {
    flex-shrink: 0;
    margin-left: 2px;
  }

  ::v-deep .van-grid {
    justify-content: center;
  }
}
</style>
